export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";